import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let __updateToastOpen = false; 
export function showUpdateToast(onRefresh) {
  const toastId = 'build-update-available';
  
  const g = (typeof window !== 'undefined') ? window : {};
  
  // If a session-expired toast is already open, do not show update toast
  if (g.__aajSessionToastOpen) return;
  if (g.__aajUpdateToastOpen || __updateToastOpen) return;
  if (toast.isActive(toastId)) return;
  
  g.__aajUpdateToastOpen = true;
  __updateToastOpen = true;

  toast.info(({ closeToast }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontWeight: 700 }}>New version available</div>
      <div style={{ fontSize: 13, opacity: 0.9 }}>
      A newer version of the application is now available. Please refresh the page to access the latest features and improvements</div>
      
      <div style={{ display: 'flex', gap: 8, marginTop: 8, justifyContent: 'flex-end' }}>
        <button
          onClick={() => {
            try { if (typeof onRefresh === 'function') onRefresh(); } catch (e) {}
            closeToast();
          }}
          style={{
            background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6,
            padding: '6px 12px', fontWeight: 700, cursor: 'pointer'
          }}
        >Refresh</button>
        <button
          onClick={closeToast}
          style={{
            background: '#e5e7eb', color: '#111827', border: 'none', borderRadius: 6,
            padding: '6px 12px', fontWeight: 600, cursor: 'pointer'
          }}
        >Later</button>
      </div>
    </div>
  ), {
    toastId,
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    hideProgressBar: true,
    onOpen: () => { /* flags already set pre-show */ },
    onClose: () => { if (g) g.__aajUpdateToastOpen = false; __updateToastOpen = false; },
  });
}
